(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

// Constructor
var CollapsibleBox = function() {
  $('.collapsible-box .toggle').click(function($event) {
      $event.preventDefault();
      $(this).closest('.collapsible-box').toggleClass('expanded');
  });
};

module.exports = CollapsibleBox;

},{}],2:[function(require,module,exports){
'use strict';

// Constructor
var CommonHeader = function () {
    $('.title-bar').waypoint(function ($direction) {
        if ($direction === 'up') {
            $('.inner-page .header').removeClass('stuck');
            $('body').removeClass('stuck');
        } else {
            $('.inner-page .header').addClass('stuck');
            $('body').addClass('stuck');
        }
    }, {
        offset: '90px'
    });
  
};

module.exports = CommonHeader;

},{}],3:[function(require,module,exports){
'use strict';

// Constructor
var MainNavigation = function () {
//    $(".nano").nanoScroller();

    $('.menu-trigger, .start-exploring-report').click(function ($event) {
        $event.preventDefault();
        $('.main-navigation .level1').addClass('active');
        $('.main-navigation-overlay').addClass('active');
        $(".nano").nanoScroller();
        $('body').addClass('locked');
    });

    $('.close-menu, .main-navigation-overlay').click(function () {
        $('.main-navigation .level1').removeClass('active');
        $('.main-navigation .level2').removeClass('active');
        $('.main-navigation .level3').removeClass('active');
        $('.main-navigation .parent').removeClass('active');
        $('.main-navigation-overlay').removeClass('active');
        $('body').removeClass('locked');
    });

    $('body').on('click', '.close-menu-3', function () {
        $('.main-navigation .level3').removeClass('active');
    });

    $('body').on('click', '.close-menu-2', function () {
        $('.main-navigation .level2').removeClass('active');
    });

    $('body').on('click', '.main-navigation .parent', function ($event) {
        $event.preventDefault();




        // If it was coming from level 1 then close the sub links
        if ($(this).closest('.level').hasClass('level1')) {
            $('.main-navigation .level2').removeClass('active');
            $('.main-navigation .level3').removeClass('active');

            // Remove the active class from the level 1 links
            $('.main-navigation .level1 .parent').removeClass('active');
        }

        // If it was coming from level 2 then close the sub links
        if ($(this).closest('.level').hasClass('level2')) {
            // Remove the active class from the level 1 links
            $('.main-navigation .level2 .parent').removeClass('active');
        }

        // Add active class to current level 1 link
        $(this).addClass('active');


        // Computes the nanoscroller height
        var $height_substractor = window.innerWidth > 1600 ? 140 : 90;

        // Activate the sub menu and add the content
        if ($(this).siblings('.sub-menu').hasClass('sub-menu-2')) {
            if ($(this).siblings('.sub-menu').html().length > 0) {
                $('.main-navigation .level2').html($(this).siblings('.sub-menu').html()).addClass('active');
            } else {
//                $('.main-navigation .level2').html('<h3>No Sub items</h3><button class="close-menu-3 close-menu-back"><i class="icon-arrow-left1"></i><span>back</span></button>').addClass('active');
            }

            var $level2_height = $('.main-navigation .level2.active').height() - $('.main-navigation .level2.active h3').height() - $('.main-navigation .level2.active button').height() - $('.main-navigation .level2.active .overview-title').height() - $height_substractor;
            $(".main-navigation .level2 .nano").height($level2_height);
            $(".main-navigation .level2 .nano").nanoScroller();

        } else {
            if ($(this).siblings('.sub-menu').html().length > 0) {
                $('.main-navigation .level3').html($(this).siblings('.sub-menu').html()).addClass('active');
            } else {
//                $('.main-navigation .level3').html('<h3>No Sub items</h3><button class="close-menu-3 close-menu-back"><i class="icon-arrow-left1"></i><span>back</span></button>').addClass('active');
            }
            setTimeout(function () {
                var $level3_height = $('.main-navigation .level2.active').height() - $('.main-navigation .level2.active h3').height() - $('.main-navigation .level2.active button').height() - $('.main-navigation .level2.active .overview-title').height() - $height_substractor;
                $(".main-navigation .level3 .nano").height($level3_height);
                $(".main-navigation .level3 .nano").nanoScroller();
            }, 400);
        }

    });

};

module.exports = MainNavigation;

},{}],4:[function(require,module,exports){
'use strict';

// Constructor
var PageScroll = function () {
    if ($('main.introduction').length > 0) {
        var $id = getUrlParam('id', 'none');
        if ($('#' + $id).length) {
            // console.log($id);
            setTimeout(function(){
                $("html, body").animate({ scrollTop: $('#' + $id).offset().top - 300 }, 1000);
            }, 300)
            $("html, body").animate({ scrollTop: $('#' + $id).offset().top - 300 }, 1000);

            // if($id === "use-of-the-ei-national-report") {
            //     $("html, body").animate({ scrollTop: $('#' + $id).offset().top - 300 }, 1000);
            //     setTimeout(function(){
            //         $("html, body").animate({ scrollTop: $('#' + $id).offset().top - 300 }, 1000);
            //     }, 300)
            // } else {
            //     $("html, body").animate({ scrollTop: $('#' + $id).offset().top - 300 }, 1000);
            // }
        }
    }
    if ($('main.appendix').length > 0) {
        console.log('appendix');
        $("html, body").animate({ scrollTop: 0 }, 0); // Scroll page to top
        setTimeout(function () {
            if ($id = getUrlBookmark()) {
                $('a[name=' + $id + ']').length ? $("html, body").animate({ scrollTop: $('a[name=' + $id + ']').offset().top - 300 }, 1000) : '';
            }
        }, 100);


        $('main.appendix .text-block a[href^="#"]').click(function ($event) {
            $event.preventDefault();
            var url = $(this).attr('href')
            var $id = url.substring(url.indexOf("#") + 1);
            $('a[name=' + $id + ']').length ? $("html, body").animate({ scrollTop: $('a[name=' + $id + ']').offset().top - 300 }, 1000) : '';
        });
    }

    function getUrlParam(parameter, defaultvalue) {
        var urlparameter = defaultvalue;
        if (window.location.href.indexOf(parameter) > -1) {
            urlparameter = getUrlVars()[parameter];
        }
        return urlparameter;
    }

    function getUrlBookmark() {
        var url = window.location.href;
        if (url.indexOf('#') > -1) {
            var $id = url.substring(url.indexOf("#") + 1);
            return $id;
        }
        return false;
    }

    function getUrlVars() {
        var vars = {};
        var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
            vars[key] = value;
        });
        return vars;
    }
};

module.exports = PageScroll;

},{}],5:[function(require,module,exports){
'use strict';

// Constructor
var TabBox = function () {
    $('.tab-box .switch button').click(function ($event) {
        $event.preventDefault();
        $(this).closest('.tab-box').find('.tab-container').removeClass('active');
        $(this).closest('.tab-box').find('.switch button').removeClass('active');
        $(this).closest('.tab-box').find('.' + $(this).data('target')).addClass('active');
        $(this).addClass('active');

        $(this).closest('.collapsible-box').addClass('expanded'); // Makes it easier to just click the tab and it expands the box
    });
};

module.exports = TabBox;

},{}],6:[function(require,module,exports){
'use strict';

// Constructor
var TitleBar = function () {

    var $url;

    $('.share-page a').click(function () {

        console.log(encodeURIComponent(window.location.origin + window.location.pathname));

        if ($(this).hasClass('facebook')) {
            $url = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(window.location.origin + window.location.pathname);
        } else if ($(this).hasClass('twitter')) {
            $url = 'https://twitter.com/intent/tweet?url=' + encodeURIComponent(window.location.origin + window.location.pathname) + '&text=' + $('.title-bar h2').text();
        } else if ($(this).hasClass('print')) {
            window.print();
            return true;
        } else if ($(this).hasClass('email')) {
            $url =  'mailto:?subject=' + $('.title-bar h2').text() + '&body=' + window.location.origin + window.location.pathname;
        }

        var height = 300;
        var width = 500;
        var left = (screen.width / 2) - (width / 2);
        var top = (screen.height / 2) - (height / 2);

        window.open($url, "", "menubar=no, toolbar=no, resizable=yes, scrollbars=yes, width=" + width + ", height=" + height + ", top=" + top + ", left=" + left);
        return true;
    })
};

module.exports = TitleBar;

},{}],7:[function(require,module,exports){
/* global Papa, $charts_collection */

'use strict';

window.charts_collection = {};
window.dataset_collection = {};
window.labels_collection = {};
window.original_labels = {};

// Constructor
var Chartblock = function () {
    var $legend_box_width = 20;
    var $legend_padding = 18;
    var $legend_font_size = 16;

    // Go through each chart element on the page
    $('.csv-chart').each(function () {
        var $header; // The header row
        var $container = $(this);
        var original = Chart.defaults.global.legend.onClick; // We keep the original legend onclick
        var $chart_reference = $container.data('reference') ? $container.data('reference') : 'no-ref-' + makeid();
        var $configuration = $container.data('configuration'); // The configuration object from the data attribute
        var $type = $configuration.type ? $configuration.type : 'horizontalBar'; // Type of chart
        var $x_axis = typeof $configuration.x_axis === 'undefined' ? true : $configuration.x_axis; // Show x axis and gridlines
        var $x_axis_label_show = typeof $configuration.x_axis_label === 'undefined' ? false : true; // Show x axis label
        var $x_axis_label_text = typeof $configuration.x_axis_label === 'undefined' ? false : $configuration.x_axis_label; // Show x axis label
        var $y_axis_label_show = typeof $configuration.y_axis_label === 'undefined' ? false : true; // Show y axis label
        var $y_axis_label_text = typeof $configuration.y_axis_label === 'undefined' ? false : $configuration.y_axis_label; // Show y axis label
        var $y_axis = typeof $configuration.y_axis === 'undefined' ? true : $configuration.y_axis; // Show y axis and gridlines
        var $y_axis_leading_zero = typeof $configuration.y_axis_leading_zero === 'undefined' ? false : $configuration.y_axis_leading_zero; // Show y axis and gridlines
        var $y_axis_suffix = typeof $configuration.y_axis_suffix === 'undefined' ? false : $configuration.y_axis_suffix; // Suffix like %
        var $y_axis_is_year = typeof $configuration.y_axis_is_year === 'undefined' ? false : $configuration.y_axis_is_year; // No number format for years
        var $y_raw = typeof $configuration.y_raw === 'undefined' ? false : $configuration.y_raw; // No number format 
        var $x_axis_is_year = typeof $configuration.x_axis_is_year === 'undefined' ? false : $configuration.x_axis_is_year; // No number format for years
        var $x_axis_no_percentage = typeof $configuration.x_axis_no_percentage === 'undefined' ? false : $configuration.x_axis_no_percentage; // Prevent adding % sign at the end
        var $x_gridlines = typeof $configuration.x_gridlines === 'undefined' ? true : $configuration.x_gridlines; // Show gridlines
        var $y_gridlines = typeof $configuration.y_gridlines === 'undefined' ? true : $configuration.y_gridlines; // Show gridlines
        var $legend = typeof $configuration.legend === 'undefined' ? true : $configuration.legend; // Show or hide legend
        var $legend_position = typeof $configuration.legend_position === 'undefined' ? 'right' : $configuration.legend_position; // Show or hide legend
        var $single_color = typeof $configuration.single_color === 'undefined' ? false : $configuration.single_color; // Force a single color on chart
        var $label_font_size = typeof $configuration.label_font_size === 'undefined' ? 12 : $configuration.label_font_size; // Size of axis labels
        var $show_data_labels = typeof $configuration.show_data_labels === 'undefined' ? false : $configuration.show_data_labels; // The label end of charts
        var $padding_right = typeof $configuration.padding_right === 'undefined' ? 0 : $configuration.padding_right; //Add padding to the cavas
        var $padding_left = typeof $configuration.padding_left === 'undefined' ? 0 : $configuration.padding_left; //Add padding to the cavas
        var $bar_line_height = typeof $configuration.bar_line_height === 'undefined' ? 35 : $configuration.bar_line_height; //Add padding to the cavas
        var $tooltip_show_currency = typeof $configuration.tooltip_show_currency === 'undefined' ? false : $configuration.tooltip_show_currency; //Show currency in tooltip
        var $tooltip_show_label = typeof $configuration.tooltip_show_label === 'undefined' ? false : $configuration.tooltip_show_label; //Show currency in tooltip
        var $tooltip_overite_label = typeof $configuration.tooltip_overite_label === 'undefined' ? false : $configuration.tooltip_overite_label; //Show currency in tooltip
        var $tooltip_show_percentage = typeof $configuration.tooltip_show_percentage === 'undefined' ? false : $configuration.tooltip_show_percentage; //Show currency in tooltip
        var $tooltip_hide_value = typeof $configuration.tooltip_hide_value === 'undefined' ? false : $configuration.tooltip_hide_value; //Hide the tooltip value only show label
        var $tooltip_number_format = typeof $configuration.tooltip_number_format === 'undefined' ? false : $configuration.tooltip_number_format; //Add thousand seperators
        var $tooltip_decimal = typeof $configuration.tooltip_decimal === 'undefined' ? false : $configuration.tooltip_decimal; //Add thousand seperators
        var $disable_filter = typeof $configuration.disable_filter === 'undefined' ? false : $configuration.disable_filter; //Disable clicking on legend
        var $chart_stack = typeof $configuration.chart_stack === 'undefined' ? true : $configuration.chart_stack; //If not defined charts are stacked by default
        var $external_filter = typeof $configuration.external_filter === 'undefined' ? false : $configuration.external_filter; //If not defined charts are stacked by default
        var $max_initial_dataset = typeof $configuration.max_initial_dataset === 'undefined' ? false : $configuration.max_initial_dataset; //How many datasets to show on initial load
        var $groupped_first_col = typeof $configuration.groupped_first_col === 'undefined' ? false : $configuration.groupped_first_col; // Change how the dataset is constructed
        var $special_mix_chart = typeof $configuration.special_mix_chart === 'undefined' ? false : $configuration.special_mix_chart; // Change how the dataset is constructed
        var $always_show_value = typeof $configuration.always_show_value === 'undefined' ? false : $configuration.always_show_value; // Change how the dataset is constructed
        var $always_show_positive = typeof $configuration.always_show_positive === 'undefined' ? false : $configuration.always_show_positive; // Done for gender chart, always have positive values
        var $step_size = typeof $configuration.step_size === 'undefined' ? false : $configuration.step_size; // Done for gender chart, always have positive values

        // Pulls the CSV data in json
        Papa.parse($configuration.url, {
            download: true,
            dynamicTyping: true,
            skipEmptyLines: true,
            complete: function ($json) {

                // Process the data
                $configuration.header ? $header = $json.data.shift() : '';
                $configuration.header ? $header.shift() : '';
                $groupped_first_col ? $header.shift() : ''; // If we are using the first col on header row to group the data then skip one more col

                // Color palettes
                var $color_codes = colorCodes();

                // Create the dataset and add the colors and labels
                var $dataset = [];
                var $groups = {};
                var $labels = [];
                var $labels_groupped = [];
                var $labels_total_line = 0;
                var $max_width = 15; // Max width of label
                $type === 'doughnut' ? $max_width = 1000 : ''; // On dougnut do not split the labels messing up the legend
                $external_filter ? $legend = false : ''; // If external_filter is set then disable the legend on the canvas

                // console.log($json.data); 


                // Rearrange the dataset
                $.each($json.data, function ($index, $value) {
                    var $group = $groupped_first_col ? $value.shift() : 'Not groupped';
                    var $label = $value.shift();
                    $groups[$group.replace(/[^A-Z0-9]/ig, "_")] = $group // Collect the groups

                    $($value).each(function ($key, $number) {
                        // If this is a multi dataset or single dataset chart 

                        // Make sure the values are numbers, we ignore %
                        if (typeof $number === 'string' && $number.indexOf("%") === -1) {
                            $number = Number($number.replace(/,\s?/g, ""));
                        }

                        var $color_index = $value.length > 1 ? $key : $index; // Define which color to pick

                        // If not a doughnut and has only 1 dataset set the color to same index

                        $value.length === 1 && $type !== 'doughnut' ? $color_index = 1 : '';
                        $value.length === 1 && $type !== 'doughnut' && !$always_show_value ? $tooltip_hide_value = true : '';

                        $dataset[$key] ? '' : $dataset[$key] = { label: '', data: [], backgroundColor: [], borderColor: [] };
                        $dataset[$key]["label"] = formatLabel($header[$key], $max_width, false);
                        $dataset[$key]["data"].push(parseFloat($number));
                        $max_initial_dataset && $key > $max_initial_dataset ? $dataset[$key]["hidden"] = true : ''; // If there is a max number of initial datasets to show


                        // If this is a line chart, then no background color
                        if ($type === 'line') {
                            $dataset[$key]["borderColor"] = $single_color ? $single_color : $color_codes[$color_index];
                            $dataset[$key]["backgroundColor"] = 'rgba(255, 255, 255, 0)';
                        } else {
                            $dataset[$key]["backgroundColor"].push($single_color ? $single_color : $color_codes[$color_index]);
                        }

                        if ($special_mix_chart) {
                            if ($header[$key] === 'Patent Family') {
                                $dataset[$key]["type"] = 'line';
                                $dataset[$key]["showLine"] = false;
                                $dataset[$key]["pointBorderWidth"] = 5;
                                // $dataset[$key]["pointBackgroundColor"] = $single_color ? $single_color : $color_codes[$color_index];
                                $dataset[$key]["borderColor"] = $single_color ? $single_color : $color_codes[$color_index];
                                $dataset[$key]["pointBackgroundColor"] = '#50E3C2';
                                $dataset[$key]["borderColor"] = '#50E3C2';
                                $dataset[$key]["pointRadius"] = 4;
                                $dataset[$key]["backgroundColor"] = ['rgba(0,0,0,0)'];
                            }
                        }
                    });

                    // The first column in the row is the label for the dataset
                    $labels.push(formatLabel($label, $max_width, $y_axis_leading_zero));

                    if ($groupped_first_col) {
                        $labels_groupped.push({ group: $group, label: formatLabel($label, $max_width, $y_axis_leading_zero) });
                    }

                    // Add the size of the label array back
                    var $formatted_label = formatLabel($label, $max_width, $y_axis_leading_zero);
                    if ($formatted_label && $formatted_label.constructor === Array) {
                        $labels_total_line = $labels_total_line + $formatted_label.length;
                    } else {
                        $labels_total_line = $labels_total_line + 1;
                    }
                });



                // Clone the dataset
                var $dataset_clone = [];
                $($dataset).each(function ($index, $data) {
                    $dataset_clone.push({ data: $data.data });
                });


                // If we have groupped dataset or dataset filter then we store the original dataset to global and work with it
                $groupped_first_col ? window.dataset_collection[$chart_reference] = $dataset_clone : '';
                $groupped_first_col ? window.labels_collection[$chart_reference] = $labels_groupped : '';
                $groupped_first_col ? window.original_labels[$chart_reference] = $labels : '';



                // If browser width < 900px reposition the legend and change padding              
                if (window.innerWidth < 700) {
                    $legend_position = 'bottom';
                    $legend_padding = 15;
                    $legend_font_size = 13;
                }

                var $chart_height = $labels_total_line * 45;
                $chart_height < 600 ? $chart_height = $labels_total_line * 65 : '';
                $chart_height < 300 ? $chart_height = 300 : ''; // Make sure the chart is min 300

                // If this is not a Doughnut or Line chart type
                if ($type !== 'doughnut' && $type !== 'line' && $type !== 'bar') {
                    $container.closest('.chart-container').css('height', $chart_height); // Adjust the canvas height
                    (parseInt($chart_height / $labels.length) - 50) < 35 ? $bar_line_height = 35 : $bar_line_height = (parseInt($chart_height / $labels.length) - 50); // Set the actual bars
                    $bar_line_height > 60 ? $bar_line_height = 60 : ''; // Cap the bar height to max 60
                    $dataset.length === 1 ? $legend = false : ''; // If there is only 1 dataset then hide the legend                    
                }

                // Draw the chart
                window.charts_collection[$chart_reference] = new Chart($container[0].getContext('2d'), {
                    type: $type,
                    data: {
                        labels: $labels,
                        datasets: $dataset
                    },
                    options: {
                        responsive: true,
                        elements: {
                            line: {
                                tension: 0, // disables bezier curves
                            }
                        },
                        maintainAspectRatio: false,
                        layout: {
                            padding: {
                                left: $padding_left,
                                right: $padding_right,
                                top: 20,
                                bottom: 20
                            }
                        },
                        tooltips: {
                            mode: 'single',
                            callbacks: {
                                // this callback is used to create the tooltip label
                                label: function (tooltipItem, data) {

                                    // console.log('tooltipItem', tooltipItem);
                                    // console.log('data', data);

                                    // get the data label and data value to display
                                    // var dataLabel;
                                    // if (data.datasets.length > 1) {
                                    // } else {

                                    // }
                                    var dataLabel =
                                        data.datasets.length > 1 ?
                                            (data.datasets[tooltipItem.datasetIndex].label[0] ?
                                                data.datasets[tooltipItem.datasetIndex].label.join(' ')
                                                : data.datasets[tooltipItem.datasetIndex].label)
                                            : (data.labels[tooltipItem.index][0] ?
                                                data.labels[tooltipItem.index].join(' ')
                                                : data.labels[tooltipItem.index]);

                                    // add the currency symbol $ to the label
                                    var value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];

                                    // Format the value
                                    if ($x_axis_is_year) {
                                        $tooltip_number_format ? value = value.toLocaleString() : '';
                                    } else {
                                        $always_show_positive && value < 0 ? value = value * -1 : '';
                                        $tooltip_decimal ? value = Number(value).toFixed($tooltip_decimal) : '';
                                        $tooltip_number_format ? value = value.toLocaleString() : '';
                                        $tooltip_show_currency ? value = '$ ' + value : '';
                                        $tooltip_show_label ? value = $tooltip_show_label + ": " + value : '';
                                        $tooltip_show_percentage ? value = value + '%' : '';
                                    }

                                    // If forced to hide value
                                    $tooltip_hide_value ? '' : dataLabel += ': ' + value;

                                    $tooltip_overite_label ? dataLabel = value : '';

                                    // If there is 1 dataset and we are on bar chart
                                    if ((data.datasets.length === 1 && $type === "horizontalBar") || data.datasets.length === 1 && $type === "bar") {
                                        return value
                                    } else {
                                        // return the text to display on the tooltip
                                        return dataLabel;
                                    }
                                }
                            }
                        },
                        legend: {
                            display: $legend,
                            position: $legend_position,
                            labels: {
                                boxWidth: $legend_box_width,
                                padding: $legend_padding,
                                fontSize: $legend_font_size,
                                fontFamily: 'Cabin',
                                filter: function ($item, $chartdata) {
                                    if (typeof $item['text'] === 'object' && $item['text'] !== null) {
                                        $item['text'] = $item['text'].join(' '); // Remove the comma from the legend label
                                    }
                                    return $item;
                                }
                            },

                            onClick: function ($event, $item) {
                                if ($disable_filter) {
                                    $event.stopPropagation();
                                } else {
                                    original.call(this, $event, $item);
                                }
                            }
                        },
                        scales: {
                            xAxes: [{
                                display: $x_axis,
                                stacked: $chart_stack,
                                gridLines: {
                                    display: $x_gridlines
                                },
                                ticks: {
                                    fontSize: $label_font_size,
                                    fontColor: '#021A2B',
                                    fontFamily: 'Cabin',
                                    autoSkip: false,
                                    callback: function (value, index, values) {

                                        // Check the largest value in the ticks. To know what devider to use
                                        var $suffix = ' k';
                                        var $divider = 0;

                                        value[0] ? value = value.join(' ') : ''; // Remove commas on x-axis #89139

                                        if ($x_axis_is_year) {
                                            // Do not format the ticks
                                        } else {
                                            var $largest = Math.max.apply(Math, values);
                                            if ($largest >= 1000000) {
                                                $suffix = ' m';
                                                $divider = 1000000;
                                            } else if ($largest >= 1000) {
                                                $suffix = ' k';
                                                $divider = 1000;
                                            }

                                            $always_show_positive && value < 0 ? value = value * -1 : '';

                                            if ($divider > 0) {
                                                value = value / $divider;
                                                value = value.toLocaleString() + $suffix;
                                            } else {
                                                $tooltip_number_format ? value = value.toLocaleString() : '';
                                            }

                                            $tooltip_show_percentage && !$x_axis_no_percentage ? value = value + '%' : '';
                                            $tooltip_show_currency ? value = '$ ' + value : '';
                                            // $tooltip_show_label ? value = $tooltip_show_label + ": " + value : '';
                                        }

                                        return value;
                                    }
                                },
                                scaleLabel: {
                                    display: $x_axis_label_show,
                                    labelString: $x_axis_label_text,
                                    padding: 20,
                                    fontSize: 18,
                                    fontColor: '#000',
                                    fontFamily: 'Cabin',
                                    fontStyle: 'bold'
                                }
                            }],
                            yAxes: [{
                                display: $y_axis,
                                barThickness: $bar_line_height,
                                stacked: $chart_stack,
                                gridLines: {
                                    display: $y_gridlines
                                },
                                ticks: {
                                    fontSize: $label_font_size,
                                    fontColor: '#021A2B',
                                    stepSize: $step_size,
                                    fontFamily: 'Cabin',
                                    callback: function (value, index, values) {

                                        // Check the largest value in the ticks. To know what devider to use
                                        var $suffix = ' k';
                                        var $divider = 0;

                                        if ($y_axis_is_year || $y_raw) {
                                            // Do not format the ticks
                                        } else {

                                            var $largest = Math.max.apply(Math, values);
                                            if ($largest > 2300) {
                                                if ($largest >= 1000000) {
                                                    $suffix = ' m';
                                                    $divider = 1000000;
                                                } else if ($largest >= 1000) {
                                                    $suffix = ' k';
                                                    $divider = 1000;
                                                }

                                                if ($divider > 0) {
                                                    value = value / $divider;
                                                    value = value.toLocaleString() + $suffix;
                                                }
                                            }
                                        }


                                        if ($y_axis_suffix) {
                                            // Do not format the ticks
                                            value = value + $y_axis_suffix;
                                        }

                                        return value;
                                    }
                                },
                                scaleLabel: {
                                    display: $y_axis_label_show,
                                    labelString: $y_axis_label_text,
                                    padding: 20,
                                    fontSize: 18,
                                    fontColor: '#000',
                                    fontFamily: 'Cabin',
                                    fontStyle: 'bold'
                                }
                            }]
                        },
                        plugins: {
                            datalabels: {
                                display: $show_data_labels,
                                color: '#005792',
                                align: 'right',
                                offset: 20,
                                anchor: 'end',
                                font: {
                                    weight: 'bold',
                                    size: '22',
                                    family: 'Cabin'
                                },
                                formatter: function (value, context) {
                                    return value + '%';
                                }

                            }
                        },
                        animation: {
                            onComplete: function () {
                                // Get the base64 for print
                                var $image_print = this.toBase64Image();
                                $container.closest('.chart-container').find('.chart-print').remove();
                                $container.closest('.chart-container').append('<img class="chart-print" src="' + $image_print + '">');
                            }
                        }
                    }

                });


                // If external_filter is set then disable the legend and add filter box on top;
                if ($external_filter) {
                    var $filter_html = '';
                    var $legend_html = '';
                    // Go through each dataset and build the list of options
                    $(window.charts_collection[$chart_reference].data.datasets).each(function ($index, $data) {
                        var $checked = !$data.hidden ? 'checked' : '';
                        var $dataset_ref = $chart_reference + "_" + $index; // Create a reference based on the chart reference and index
                        var $color = $type === 'line' ? $data['borderColor'] : $data['backgroundColor'][0];
                        var $data_value = $data["label"][0] ? $data["label"][0] : $data["label"];
                        var $data_label = $data["label"][0] ? $data["label"].join(' ') : $data["label"];
                        // console.log($data);
                        $filter_html +=
                            "<li class='table_group_" + $chart_reference + "'>" +
                            "<input " + $checked + " type='checkbox' id='filter_" + $dataset_ref + "' data-dataset-index='" + $index + "' data-chart-target='" + $chart_reference + "'  value='" + $data_value + "'/>" +
                            "<label style='color:" + $color + "' for='filter_" + $dataset_ref + "'><span>" + $data_label + "</span></label>" +
                            "</li>";

                        if ($checked === 'checked') {
                            $legend_html += "<li><label style='color:" + $color + "' ><span>" + $data_label + "</span></label></li>";
                        }
                    });
                    var $label_text = $max_initial_dataset ? '...' : 'All';
                    $filter_html = "<div class='chart-filter chart_filter_" + $chart_reference + "'>" +
                        "<div class='right'>" +
                        "<div class='label'>View FoR</div>" +
                        "<div class='dropdown widget-container'>" +
                        "<button class='selected'>" +
                        "<span>" + $label_text + "</span>" +
                        "</button>" +
                        "<ul class='list'>" + $filter_html + "</ul>" +
                        "</div></div></div>";

                    $legend_html = "<ul class='legend_html'>" + $legend_html + "</ul>";

                    $container.closest('.chart-container').before($filter_html);
                    $container.closest('.chart-container').after($legend_html);

                    // Bind the change action to the filter checkboxes
                    $(".dropdown.widget-container .list li.table_group_" + $chart_reference + " input").change(function () {

                        // When a checkbox is ticked go through the list and build the search filter
                        var $value = '';
                        var $legend_html = "";
                        var $chart_target = $(this).data('chart-target');

                        // Disable all the datasets and enable only the active one
                        $(window.charts_collection[$chart_reference].data.datasets).each(function ($index, $value) {
                            window.charts_collection[$chart_reference].getDatasetMeta($index).hidden = true;
                        });

                        // Go through the ticked checkbox and collect the data & Enable the ticked datasets
                        $(this).closest('.dropdown.widget-container').find("input:checked").each(function () {
                            $value += ($(this).val().length > 4 ? $(this).val().substr(0, 2) : $(this).val()) + "|"
                            window.charts_collection[$chart_reference].getDatasetMeta($(this).data('dataset-index')).hidden = false;

                            $legend_html += "<li><label style='" + $(this).siblings('label').attr('style') + "' ><span>" + $(this).siblings('label').text() + "</span></label></li>";
                        })


                        // After collecting all the values check if there is anything to filter
                        if ($value) {
                            // If there a value ticked then we show only the ticked ones
                            $(this).closest('.widget-container').find('.selected span').html($value.slice(0, -1).replace(/\|/g, ", "));
                        } else {
                            // If no checkbox is ticked then show everything
                            $(this).closest('.widget-container').find('.selected span').html('All');
                            $(window.charts_collection[$chart_reference].data.datasets).each(function ($index, $value) {
                                window.charts_collection[$chart_reference].getDatasetMeta($index).hidden = false;
                            });
                        }

                        // Apply to chart
                        window.charts_collection[$chart_reference].update();


                        // Go through all the selected and build the legend list again
                        $(this).closest('.chart').find('.legend_html').html($legend_html);

                    });

                    // Bind action to expand the filter list
                    $('.chart_filter_' + $chart_reference + ' .widget-container button').click(function ($event) {
                        $event.stopPropagation()
                        !$(this).closest('.collapsible-box').hasClass('expanded') ? $(this).closest('.collapsible-box').find('.toggle').click() : '';
                        $(this).siblings('.list').toggleClass('active');
                        $(this).toggleClass('active');
                    })

                    // Clicking on the open filer dropdown. Stop propagation
                    $('.chart_filter_' + $chart_reference + ' .widget-container .list').click(function ($event) {
                        $event.stopPropagation();
                    });

                }

                // If there are groups on the chart
                if ($groupped_first_col) {

                    var $filter_html = '';
                    var $this_chart_reference = $chart_reference + '_cohort';
                    var $label_text = 'View Cohorts';

                    // Go through each dataset and build the list of options
                    $.each($groups, function ($index, $data) {
                        // console.log($index);
                        var $dataset_ref = $this_chart_reference + "_" + $index + "_groups"; // Create a reference based on the chart reference and index
                        var $data_value = $data;

                        $filter_html +=
                            "<li class='table_group_" + $this_chart_reference + "'>" +
                            "<input  type='checkbox' id='filter_" + $dataset_ref + "' data-dataset-index='" + $index + "' data-chart-target='" + $chart_reference + "'  value='" + $data_value + "'/>" +
                            "<label for='filter_" + $dataset_ref + "'><span>" + $data + "</span></label>" +
                            "</li>";
                    });

                    $filter_html = "<div class='chart-filter groups chart_filter_" + $this_chart_reference + "'>" +
                        "<div class='left'>" +
                        "<div class='label'>" + $label_text + "</div>" +
                        "<div class='dropdown widget-container'>" +
                        "<button class='selected'>" +
                        "<span>All</span>" +
                        "</button>" +
                        "<ul class='list'>" + $filter_html + "</ul>" +
                        "</div></div></div>";

                    $container.closest('.chart-container').before($filter_html);

                    // Bind the change action to the filter checkboxes
                    $(".dropdown.widget-container .list li.table_group_" + $this_chart_reference + " input").change(function () {

                        // When a checkbox is ticked go through the list and build the search filter
                        var $value = '';
                        var $chart_target = $(this).data('chart-target');
                        var $selected_groups = [];


                        // // Go through the ticked checkbox and collect the data & Enable the ticked datasets
                        $(this).closest('.dropdown.widget-container').find("input:checked").each(function () {
                            var $raw_value = $(this).val();
                            switch ($raw_value) {
                                case 'Group of Eight (Go8)':
                                    $raw_value = 'Go8';
                                    break;
                                case 'Australian Technology Network (ATN)':
                                    $raw_value = 'ATN';
                                    break;
                                case 'Innovative Research Universities (IRU)':
                                    $raw_value = 'IRU';
                                    break;
                                case 'Regional Universities Network (RUN)':
                                    $raw_value = 'RUN';
                                    break;

                                default:
                                    break;
                            }
                            $value += $raw_value + "|"

                            // Make a list of selected items
                            $selected_groups.push($(this).val())
                        })

                        // console.log('Window chart', window.charts_collection[$chart_reference]);
                        // console.log('Window dataset', window.dataset_collection[$chart_reference]);
                        // console.log('Window labels', window.labels_collection[$chart_reference]);
                        // console.log('Selected groups', $selected_groups);



                        // Reset the chart to it's original state
                        window.charts_collection[$chart_reference].data.labels = window.original_labels[$chart_reference];

                        $(window.charts_collection[$chart_reference].data.datasets).each(function ($index, $data) {
                            window.charts_collection[$chart_reference].data.datasets[$index].data = window.dataset_collection[$chart_reference][$index].data
                        })
                        // window.charts_collection[$chart_reference].data.datasets = window.dataset_collection[$chart_reference];

                        // After collecting all the values check if there is anything to filter
                        if ($value) {
                            // If there a value ticked then we show only the ticked ones
                            $(this).closest('.widget-container').find('.selected span').html($value.slice(0, -1).replace(/\|/g, ", "));
                            // window.charts_collection[$chart_reference].data.labels = window.charts_collection[$chart_reference].data.labels.pop();

                            // Rebuild the list of labels and collect the index 
                            var $list_of_selected_labels_index = [];
                            var $list_of_selected_labels = [];
                            $(window.labels_collection[$chart_reference]).each(function ($label_index, $value) {
                                var $label_group = $value.group;

                                if ($selected_groups.indexOf($label_group) > -1) {
                                    $list_of_selected_labels.push($value.label);
                                    $list_of_selected_labels_index.push($label_index);
                                }
                            });

                            // console.log('$list_of_selected_labels', $list_of_selected_labels);
                            // console.log('$list_of_selected_labels_index', $list_of_selected_labels_index);


                            // Go through each dataset and exclude the ones that are not part of selected labels based on index
                            // var $original_datasets = window.dataset_collection[$chart_reference];
                            var $filtered_dataset = [];

                            $(window.charts_collection[$chart_reference].data.datasets).each(function ($index, $dataset) {
                                var $filtered_data = [];
                                $($dataset.data).each(function ($data_label_index, $data) {
                                    if ($list_of_selected_labels_index.indexOf($data_label_index) > -1) {
                                        $filtered_data.push($data);
                                    }
                                });
                                $dataset['data'] = $filtered_data;
                                $filtered_dataset.push($dataset);
                                // var $filtered_dataset_index = $filtered_dataset.push($dataset);
                                // console.log($filtered_dataset_index -1);
                                // $filtered_dataset[$filtered_dataset_index -1].data = $filtered_data;
                            })

                            // console.log('Filtered dataset', $filtered_dataset);

                            // Update the chart label and dataset
                            window.charts_collection[$chart_reference].data.labels = $list_of_selected_labels;
                            window.charts_collection[$chart_reference].data.datasets = $filtered_dataset;

                        } else {
                            // If no checkbox is ticked then show everything
                            $(this).closest('.widget-container').find('.selected span').html('All');

                        }


                        // Compute the new chart height
                        var $bar_thickness = window.charts_collection[$chart_reference].options.scales.yAxes[0].barThickness;
                        var $number_of_ticks_on_y = window.charts_collection[$chart_reference].data.labels.length;
                        var $chart_height = ($bar_thickness + 45) * $number_of_ticks_on_y;
                        $(this).closest('.chart').find('.chart-container').css('height', $chart_height); // Adjust the canvas height

                        // // Apply to chart
                        window.charts_collection[$chart_reference].resize();
                        window.charts_collection[$chart_reference].update();
                    });

                    // Bind action to expand the filter list
                    $('.chart_filter_' + $this_chart_reference + ' .widget-container button').click(function ($event) {
                        $event.stopPropagation()
                        !$(this).closest('.collapsible-box').hasClass('expanded') ? $(this).closest('.collapsible-box').find('.toggle').click() : '';
                        $(this).siblings('.list').toggleClass('active');
                        $(this).toggleClass('active');
                    })

                    // Clicking on the open filer dropdown. Stop propagation
                    $('.chart_filter_' + $this_chart_reference + ' .widget-container .list').click(function ($event) {
                        $event.stopPropagation();
                    });
                }


            },
            error: function ($err, $file, $inputElem, $reason) {
                console.log('Full error', $err);
                console.log('Error message', $err['message']);
                $container.closest('.chart-container').css('height', 'auto');
                $container.closest('.collapsible-box').addClass('no-data');
                if ($err['message'] === 'Not Found' || $err['message'] === '') {
                    var $textfile = $configuration.url.substr(0, $configuration.url.lastIndexOf("/") + 1) + 'no.chart.footnote.txt'; // remove everything after the last backslash
                    var $error_message = "Data not found";
                    $.ajax({
                        url: $textfile
                    }).done(function ($data) {
                        $data ? $error_message = $data : '';
                        $container.replaceWith("<div class='no-chart not-found'>" + $error_message + "</div>");
                    }).fail(function ($error) {
                        $container.replaceWith("<div class='no-chart not-found'>" + $error_message + "</div>");
                    });
                }
            }
        });
    });

    // Clicking on body to close the filters
    $('body').click(function () {
        $('.widget-container .selected').removeClass('active');
        $('.widget-container .list').removeClass('active');
    })

    $(window).resize(function () {
        if (window.innerWidth < 700) {
            for (var key in window.charts_collection) {
                if (window.charts_collection.hasOwnProperty(key)) {
                    window.charts_collection[key].options.legend.position = "bottom";
                    window.charts_collection[key].options.legend.labels = {
                        boxWidth: 20,
                        padding: 15,
                        fontSize: 13,
                        fontFamily: 'Cabin'
                    };
                }
            }
        }
        if (window.innerWidth > 700) {
            for (var key in window.charts_collection) {
                if (window.charts_collection.hasOwnProperty(key)) {
                    window.charts_collection[key].options.legend.position = "right";
                    window.charts_collection[key].options.legend.labels = {
                        boxWidth: $legend_box_width,
                        padding: $legend_padding,
                        fontSize: $legend_font_size,
                        fontFamily: 'Cabin'
                    };
                }
            }
        }
    });

    function makeid() {
        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (var i = 0; i < 5; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));

        return text;
    }

    function formatLabel(str, maxwidth, $y_axis_leading_zero) {

        if (str && $y_axis_leading_zero && str.toString().length < 4) {
            str = '0' + str.toString();
        }

        if (typeof str === 'string') {
            var sections = [];
            var words = str.split(" ");
            var temp = "";

            words.forEach(function (item, index) {
                if (temp.length > 0) {
                    var concat = temp + ' ' + item;

                    if (concat.length > maxwidth) {
                        sections.push(temp);
                        temp = "";
                    } else {
                        if (index === (words.length - 1)) {
                            sections.push(concat);
                            return;
                        } else {
                            temp = concat;
                            return;
                        }
                    }
                }

                if (index === (words.length - 1)) {
                    sections.push(item);
                    return;
                }

                if (item.length < maxwidth) {
                    temp = item;
                } else {
                    sections.push(item);
                }

            });

            return sections;
        } else {
            return str;
        }
    }

    function colorCodes() {
        var $color_codes = [];
        $color_codes[0] = 'rgba(11,28,42,1)';
        $color_codes[1] = 'rgba(60,123,191,1)';
        $color_codes[2] = 'rgba(96,43,83,1)';
        $color_codes[3] = 'rgba(65,129,108,1)';
        $color_codes[4] = 'rgba(120,80,138,1)';
        $color_codes[5] = 'rgba(0,129,138,1)';
        $color_codes[6] = 'rgba(13,102,108,1)';
        $color_codes[7] = 'rgba(75,65,129,1)';
        $color_codes[8] = 'rgb(15,178,53)';
        $color_codes[9] = 'rgb(172,208,81)';
        $color_codes[10] = 'rgb(32,17,61)';
        $color_codes[11] = 'rgb(118,144,51)';
        $color_codes[12] = 'rgb(66,104,138)';
        $color_codes[13] = 'rgb(245,166,35)';
        $color_codes[14] = 'rgb(67,88,14)';
        $color_codes[15] = 'rgb(147,57,68)';
        $color_codes[16] = 'rgb(201,84,190)';
        $color_codes[17] = 'rgb(121,22,132)';
        $color_codes[18] = 'rgb(98,123,106)';
        $color_codes[19] = 'rgb(80,215,227)';
        $color_codes[20] = 'rgb(154,60,42)';
        $color_codes[21] = 'rgb(58,133,99)';
        $color_codes[22] = 'rgb(139,87,42)';
        $color_codes[23] = 'rgb(86,81,144)';
        $color_codes[24] = 'rgb(126,211,33)';
        $color_codes[25] = 'rgb(224,16,77)';
        $color_codes[26] = 'rgb(144,19,254)';
        $color_codes[27] = 'rgb(194,125,11)';
        $color_codes[28] = 'rgb(173,162,89)';
        $color_codes[29] = 'rgb(133,200,185)';
        $color_codes[30] = 'rgb(53,97,3)';
        return $color_codes;
    }
};

module.exports = Chartblock;

},{}],8:[function(require,module,exports){
/* global Papa */

'use strict';

// Constructor
var Table = function () {

    $('.csv-table').each(function () {
        var $header; // The header row
        var $footer; // The footer row
        var $container = $(this);
        var $configuration = $container.data('configuration'); // The configuration object from the data attribute
        var $table_css_class = $configuration.style ? $configuration.style : '';
        var $decimal_places = typeof $configuration.decimal_places === 'undefined' ? false : $configuration.decimal_places; //Decimal places to show
        var $raw_value = typeof $configuration.raw_value === 'undefined' ? false : $configuration.raw_value; //Decimal places to show

        // console.log($table_css_class);

        // Pulls the CSV data in json
        Papa.parse($configuration.url, {
            download: true,
            dynamicTyping: false,
            skipEmptyLines: true,
            complete: function ($json) {


                // Process the data
                $configuration.header ? $header = $json.data.shift() : '';
                $configuration.footer ? $footer = $json.data.pop() : '';

                // Output the HTML structure for the table
                var $html = "";
                $html += '<table class="' + $table_css_class + '">';
                if ($configuration.header) {
                    $html += '<thead><tr>';
                    $($header).each(function ($index, $value) {
                        $html += '<th>' + $value + '</th>';
                    });
                    $html += '</tr></thead>';
                }
                if ($json.data) {
                    $html += '<tbody>';
                    $($json.data).each(function ($index, $row) {

                        // Special case #87586
                        if ($row.length === 2) {
                            if ($row[0] === 'Patents' && $row[1] !== '-') {
                                $row[1] = Number(parseFloat(Number($row[1].replace(/,\s?/g, ""))).toFixed(1)).toLocaleString(undefined, { minimumFractionDigits: 1 });
                            }
                            if ($row[0] === 'FTEs' && $row[1] !== '-') {
                                $row[1] = Number(parseFloat(Number($row[1].replace(/,\s?/g, ""))).toFixed(1)).toLocaleString(undefined, { minimumFractionDigits: 1 });
                            }
                            if ($row[0] === 'Research outputs' && $row[1] !== '-') {
                                $row[1] = Number(parseFloat(Number($row[1].replace(/,\s?/g, ""))).toFixed(1)).toLocaleString(undefined, { minimumFractionDigits: 1 });
                            }
                        }

                        $html += '<tr>';
                        $($row).each(function ($index, $cell) {
                            if ($raw_value) {
                                // Do nothing
                            } else {
                                if ($decimal_places && $index !== 0 && $cell !== '-' && $cell !== '–') {
                                    $cell = Number(parseFloat(Number($cell.replace(/,\s?/g, ""))).toFixed($decimal_places)).toLocaleString(undefined, { minimumFractionDigits: $decimal_places });
                                }
                            }
                            $html += '<td>' + $cell + '</td>';
                        });
                        $html += '</tr>';
                    });
                    $html += '</tbody>';
                }
                if ($configuration.footer) {
                    $html += '<tfoot><tr>';
                    $($footer).each(function ($index, $value) {
                        if ($raw_value) {
                            // Do nothing
                        } else {
                            if ($decimal_places && $index !== 0 && $value !== '-' && $value !== '–') {
                                $value = parseFloat(Number($value.replace(/,\s?/g, ""))).toFixed($decimal_places).toLocaleString();
                            }
                        }
                        $html += '<td>' + $value + '</td>';
                    });
                    $html += '</tr></tfoot>';
                }
                $html += '</table>';

                $container.html($html);


                // Make the dataTable
                var $columnsDefs;

                // Show only 8 columns on the display
                if ($header.length > 8 && $configuration['limit_cols_to_8']) {
                    $columnsDefs = [
                        {
                            "targets": [1, 2, 3, 4, 5, 6, 7, 8], // We can make this a configuration
                            "visible": true
                        },
                        {
                            "targets": ['_all'],
                            "visible": false
                        }
                    ];
                    $configuration['columnDefs'] = $columnsDefs;
                }


                if ($configuration['stick_left_col'] && window.innerWidth > 1200) {
                    // $configuration['fixedColumns'] = {leftColumns: 1};
                    // $configuration['scrollX'] = true;
                }
                if (window.innerWidth <= 1200) {
                    // $configuration['scrollX'] = true;
                }

                // $container.find('table').DataTable($configuration);
                if (!$configuration['nodatatable']) {
                    $container.find('table').DataTable($configuration);
                }
            },
            error: function ($err, $file, $inputElem, $reason) {
                $container.closest('.collapsible-box').addClass('no-data');
                if ($err['message'] === 'Not Found' || $err['message'] === '') {
                    var $textfile = $configuration.url.substr(0, $configuration.url.lastIndexOf("/") + 1) + 'no.table.footnote.txt'; // remove everything after the last backslash
                    var $error_message = "Data not found";
                    $.ajax({
                        url: $textfile
                    }).done(function ($data) {
                        $data ? $error_message = $data : '';
                        $container.replaceWith("<div class='no-table not-found'>" + $error_message + "</div>");
                    }).fail(function ($error) {
                        $container.replaceWith("<div class='no-table not-found'>" + $error_message + "</div>");
                    });
                }
            }
        });
    });
};

module.exports = Table;

},{}],9:[function(require,module,exports){
/* global Papa */

'use strict';

// Constructor
var TableSection1 = function () {

    $('.csv-table-section1').each(function () {
        var $header; // The header row
        var $footer; // The footer row
        var $container = $(this);
        var $configuration = $container.data('configuration'); // The configuration object from the data attribute
        var $table_css_class = $configuration.style ? $configuration.style : '';
        var $decimal_places = typeof $configuration.decimal_places === 'undefined' ? false : $configuration.decimal_places; //Decimal places to show
        var $raw_value = typeof $configuration.raw_value === 'undefined' ? false : $configuration.raw_value; //Decimal places to show

        // console.log($table_css_class);

        // Pulls the CSV data in json
        Papa.parse($configuration.url, {
            download: true,
            dynamicTyping: false,
            skipEmptyLines: true,
            complete: function ($json) {

                // Process the data
                $configuration.header ? $header = $json.data.shift() : '';
                $configuration.footer ? $footer = $json.data.pop() : '';

                // Output the HTML structure for the table
                var $html = "";
                $html += '<table class="' + $table_css_class + '">';
                if ($configuration.header) {
                    $html += '<thead><tr>';
                    $($header).each(function ($index, $value) {
                        $html += '<th>' + $value + '</th>';
                    });
                    $html += '</tr></thead>';
                }
                if ($json.data) {
                    $html += '<tbody>';


                    var $forgroup_class = "";

                    $($json.data).each(function ($index, $row) {
                        var $row_class = '';

                        // If the first col is empty we highlight the row as heading
                         $row[0].length < 1  ? $row_class = " heading-row " : '';

                        // Special case #87586
                        if ($row.length === 2) {
                            if ($row[0] === 'Patents' && $row[1] !== '-') {
                                $row[1] = parseFloat(Number($row[1].replace(/,\s?/g, ""))).toFixed(1).toLocaleString();
                            }
                            if ($row[0] === 'FTEs' && $row[1] !== '-') {
                                $row[1] = parseFloat(Number($row[1].replace(/,\s?/g, ""))).toFixed(1).toLocaleString();
                            }
                            if ($row[0] === 'Research outputs' && $row[1] !== '-') {
                                $row[1] = parseFloat(Number($row[1].replace(/,\s?/g, ""))).toFixed(1).toLocaleString();
                            }
                        }

                        // If on table "Research outputs across ERA rounds" then add the class
                        if ($configuration['tableheadertitle'] === 'Research outputs across ERA rounds') {
                            if ($index === 0 || $index === 5) {
                                $row_class = 'heading-row';
                            }
                        }

 

                        $html += '<tr class="' + $row_class + $forgroup_class + '">';
                        $($row).each(function ($index, $cell) {

                            if ($raw_value) {
                                $html += '<td>' + $cell + '</td>';
                            } else {
                                // If defined to have decimal places
                                if ($decimal_places && $decimal_places !== 0 && $index !== 0 && $cell !== '' && $cell !== '-' && $cell !== '–') {
                                    $cell = Number(parseFloat(Number($cell.replace(/,\s?/g, ""))).toFixed($decimal_places)).toLocaleString(undefined, { minimumFractionDigits: $decimal_places });
                                }

                                // If no decimal places still need thousand seperators
                                if ($decimal_places === 0 && $index !== 0 && $cell !== '' && $cell !== '-' && $cell !== '–') {
                                    $cell = Number(parseFloat(Number($cell.replace(/,\s?/g, ""))).toFixed(0)).toLocaleString(undefined, { minimumFractionDigits: 0 });
                                }

                                $html += '<td>' + $cell + '</td>';
                            }
                        });
                        $html += '</tr>';
                    });
                    $html += '</tbody>';
                }
                if ($configuration.footer) {
                    $html += '<tfoot><tr>';
                    $($footer).each(function ($index, $value) {
                        if ($raw_value) {
                            $html += '<td>' + $cell + '</td>';
                        } else {
                            if ($decimal_places && $index !== 0 && $value !== '-' && $value !== '–') {
                                $value = Number(parseFloat(Number($value.replace(/,\s?/g, ""))).toFixed($decimal_places)).toLocaleString(undefined, { minimumFractionDigits: $decimal_places });
                            }
                            $html += '<td>' + $value + '</td>';
                        }
                    });
                    $html += '</tr></tfoot>';
                }
                $html += '</table>';

                $container.html($html);


                // Make the dataTable
                var $columnsDefs;

                // Show only 8 columns on the display
                if ($header && $header.length > 8 && $configuration['limit_cols_to_8']) {
                    $columnsDefs = [
                        {
                            "targets": [1, 2, 3, 4, 5, 6, 7, 8], // We can make this a configuration
                            "visible": true
                        },
                        {
                            "targets": ['_all'],
                            "visible": false
                        }
                    ];
                    $configuration['columnDefs'] = $columnsDefs;
                }


                if ($configuration['stick_left_col'] && window.innerWidth > 1200) {
                    // $configuration['fixedColumns'] = {leftColumns: 1};
                    // $configuration['scrollX'] = true;
                }
                if (window.innerWidth <= 1200) {
                    // $configuration['scrollX'] = true;
                }

                if (!$configuration['nodatatable']) {
                    $container.find('table').DataTable($configuration);
                }
            },
            error: function ($err, $file, $inputElem, $reason) {
                $container.closest('.collapsible-box').addClass('no-data');
                if ($err['message'] === 'Not Found' || $err['message'] === '') {
                    var $textfile = $configuration.url.substr(0, $configuration.url.lastIndexOf("/") + 1) + 'no.table.footnote.txt'; // remove everything after the last backslash
                    var $error_message = "Data not found";
                    $.ajax({
                        url: $textfile
                    }).done(function ($data) {
                        $data ? $error_message = $data : '';
                        $container.replaceWith("<div class='no-table not-found'>" + $error_message + "</div>");
                    }).fail(function ($error) {
                        $container.replaceWith("<div class='no-table not-found'>" + $error_message + "</div>");
                    });
                }
            }
        });
    });
};

module.exports = TableSection1;

},{}],10:[function(require,module,exports){
/* global Papa */

"use strict";

// Constructor
var TableSection4 = function () {
    var $table_counter = 0;
    var $tables = [];
    $(".csv-table-section4").each(function () {
        var $header; // The header row
        var $footer; // The footer row
        var $container = $(this);
        var $configuration = $container.data("configuration"); // The configuration object from the data attribute
        var $table_css_class = $configuration.style ? $configuration.style : "";
        // var $decimal_places = typeof $configuration.decimal_places === "undefined" ? false : $configuration.decimal_places; //Decimal places to show
        var $decimal_places = $configuration['show_all_columns'] ? false : 1; //Decimal places to show
        var $forgroup_filter = [];
        var $column_filters = [];
        var $total_columns_index = [];
        var $raw_value = typeof $configuration.raw_value === 'undefined' ? false : $configuration.raw_value; //Decimal places to show

        // Pulls the CSV data in json
        Papa.parse($configuration.url, {
            download: true,
            dynamicTyping: false,
            skipEmptyLines: true,
            complete: function ($json) {

                // Increment the table counter to use for IDs etc
                $table_counter++;

                // Process the data
                $configuration.header ? ($header = $json.data.shift()) : "";
                $configuration.footer ? ($footer = $json.data.pop()) : "";

                // Output the HTML structure for the table
                var $html = "";
                $html += '<table class="' + $table_css_class + '">';

                // Add the header
                if ($configuration.header) {
                    // Start the header column
                    $html += "<thead><tr>";
                    // Addind the group column
                    $html += "<th>forgroup</th>";

                    // Go through all the header cell
                    $($header).each(function ($index, $value) {
                        var $cell_class = "";
                        // Add class to second col to align text
                        $index === 1 ? $cell_class = "left_align" : '';
                        // Add the class and cell value for the header
                        $html += "<th class='" + $cell_class + "'>" + $value + "</th>";
                        // If this is a total cell add to array to make background darker
                        $value.toLowerCase().indexOf('total') !== -1 ? $total_columns_index.push($index) : '';

                        $column_filters.push({ index: $index + 1, label: $value });
                    });


                    $html += "</tr></thead>";
                }

                // Addthe body
                if ($json.data) {
                    $html += "<tbody>";

                    var $forgroup = "";
                    var $forgroup_label = "";
                    var $forgroup_class = "";
                    $($json.data).each(function ($index, $row) {

                        // If the FoR code is one or 3 numbers long add the Zero prefix
                        $row[0].length < 2 || $row[0].length === 3 ? $row[0] = "0" + $row[0] : '';

                        // Get the Parent FORCode to group the rows
                        if ($row[0].length < 3) {
                            $forgroup = $row[0];
                            $forgroup_label = $row[1];
                            $forgroup_class = "group_header";
                            $forgroup_filter.push({ code: $forgroup, label: $forgroup_label });
                        } else {
                            $forgroup_class = "";
                        }

                        // Add the group class to the row if it is the first item
                        $html += '<tr class="' + $forgroup_class + '">';

                        // Add the first cell as the FoR group
                        $html += "<td class='forgroup_cell'>" + $forgroup + "</td>";

                        // Go through each cell and add
                        $($row).each(function ($index, $cell) {
                            var $cell_class = "";

                            if ($raw_value) {
                                // Do nothing
                            } else {
                                // Make sure the value in the cell is 1 decimal place and thousand seperated
                                if ($decimal_places && $index !== 0 && $index !== 1 && $cell !== "-") {
                                    $cell = parseFloat(Number($cell.replace(/,\s?/g, ""))).toFixed($decimal_places).toLocaleString();
                                    $cell = Number($cell).toLocaleString() // Not sure why we need this
                                }
                            }

                            // Make sure the second column containing the FoR name is left aligned
                            $index === 1 ? $cell_class = "left_align" : '';

                            // If the cell is part of the total cell array mark it to change the background color
                            $total_columns_index.indexOf($index) !== -1 ? $cell_class = "total_cell" : '';

                            // Add the cell data and class
                            $html += "<td class='" + $cell_class + "'>" + $cell + "</td>";
                        });

                        $html += "</tr>";
                    });
                    $html += "</tbody>";
                }

                // Add the footer
                if ($configuration.footer) {

                    // Start of footer
                    $html += "<tfoot><tr>";
                    // Add a blank column for the total
                    $html += "<td></td>";

                    // Go through each footer cell
                    $($footer).each(function ($index, $value) {
                        // Make sure the value is 1 decimal place and has thousand seperator

                        if ($raw_value) {
                            // Do nothing
                        } else {
                            if ($decimal_places && $index !== 0 && $index !== 1 && $value !== "-") {
                                $value = parseFloat(Number($value.replace(/,\s?/g, ""))).toFixed($decimal_places).toLocaleString();
                                $value = Number($value).toLocaleString() // Not sure why we need this
                            }
                        }
                        // Add the value
                        $html += "<td>" + $value + "</td>";
                    });

                    // Close the footer
                    $html += "</tr></tfoot>";
                }

                // Close the table
                $html += "</table>";

                // Add the table on the page
                $container.html($html);



                // Create the filters for FoR group
                var $filter_html = "";

                // Go through the filter array
                $($forgroup_filter).each(function ($index, $data) {

                    // Add the filter markup
                    $filter_html +=
                        "<li class='table_group_" + $table_counter + "'>" +
                        "<input type='checkbox' id='for_filter_" + $table_counter + "_" + $data["code"] + "' data-table-target='" + $table_counter + "'  value='" + $data["code"] + "'/>" +
                        "<label for='for_filter_" + $table_counter + "_" + $data["code"] + "'>" + $data["code"] + " " + $data["label"] + "</label>" +
                        "</li>";
                });

                // Add the FoR filter
                $container.closest('.section4-tables').find(".dropdown.widget-container .list").html($filter_html);



                // Make the dataTable
                var $columnsDefs;



                // Show only 8 columns on the display
                $columnsDefs = [
                    {
                        targets: 0,
                        searchable: true,
                        visible: false
                    },
                    {
                        // targets: [0, 1, 2, 3, 4, $header.length - 1, $header.length], // We can make this a configuration
                        targets: ["_all"], // We can make this a configuration
                        visible: true
                    },
                    {
                        targets: ["_all"],
                        searchable: false,
                        visible: false
                    }
                ];

                // console.log($columnsDefs);

                $configuration["show_all_columns"] ? $columnsDefs[1] = { targets: [1, 2, 3], visible: true } : '';

                $configuration["columnDefs"] = $columnsDefs;

                // Configuration for buttons to filter columns 
                $configuration["buttons"] = [
                    {
                        extend: "colvis",
                        text: "Columns to display",
                        background: true,
                        backgroundClassName: 'fancy-table-button-background'
                    }
                ];

                // Make the table a Datatable
                $tables['table_' + $table_counter] = $container.find("table").DataTable($configuration);

                // Add the column filter buttons
                // console.log($tables['table_' + $table_counter].buttons().container().html());
                // var $button_html = $tables['table_' + $table_counter].buttons().container().html();
                // $container.closest(".table").find(".buttons").append($button_html);

                $tables['table_' + $table_counter].buttons().container().appendTo($container.closest(".table").find(".buttons"));



                // Bind the change action to the filter checkboxes
                $(".dropdown.widget-container .list li.table_group_" + $table_counter + " input").change(function () {

                    // When a checkbox is ticked go through the list and build the search filter
                    var $value = '';
                    var $table_target = $(this).data('table-target');

                    $(this).closest('.dropdown.widget-container').find("input:checked").each(function () {
                        $value += $(this).val() + "|"
                    })

                    // console.log($value);

                    // After collecting all the values check if there is anything to filter
                    if ($value) {
                        // Use a regex to filter the full value
                        // console.log($table_target);
                        // console.log($tables['table_' + $table_target]);
                        $tables['table_' + $table_target].search("^\\s*(" + $value + ")\\s*$", true, false, true).draw();
                        $(this).closest('.widget-container').find('.selected span').html($value.slice(0, -1).replace(/\|/g, ", "));

                    } else {
                        // If no checkbox is ticked then show everything
                        $tables['table_' + $table_target].search('').draw();
                        $(this).closest('.widget-container').find('.selected span').html('All');
                    }

                });

            },
            error: function ($err, $file, $inputElem, $reason) {

                $container.closest(".collapsible-box").addClass("no-data");
                if ($err["message"] === "Not Found" || $err["message"] === "") {
                    var $textfile = $configuration.url.substr(0, $configuration.url.lastIndexOf("/") + 1) + "no.table.footnote.txt"; // remove everything after the last backslash
                    var $error_message = "Data not found";
                    $.ajax({
                        url: $textfile
                    })
                        .done(function ($data) {
                            $data ? ($error_message = $data) : "";
                            $container.replaceWith("<div class='no-table not-found'>" + $error_message + "</div>");
                        })
                        .fail(function ($error) {
                            $container.replaceWith("<div class='no-table not-found'>" + $error_message + "</div>");
                        });
                }
            }
        });
    });

    // Make sure there is no empty table
    $('body').on('click', ".column-filter-buttons.widget-container button.buttons-columnVisibility", function ($event) {
        if ($(this).closest('.column-filter-buttons').find('.buttons-columnVisibility.active').length === 0) {
            $(this).closest('.column-filter-buttons').find('.buttons-columnVisibility').each(function () {
                if ($(this).data('cv-idx') !== 0) {
                    $(this).addClass('auto-clicked');
                    $(this).click();
                }
            })
        }
    });
    $('body').on('click', ".column-filter-buttons.widget-container button.buttons-colvis", function ($event) {
        // $event.preventDefault();
        // $event.stopPropagation();
        // var $button = $(this);

        // if ($button.hasClass('clicked')) {

        //     setTimeout(function () {
        //         $button.closest('.column-filter-buttons').find('.dt-button-collection').hide();
        //         $button.removeClass('clicked')
        //         console.log('clicked');
        //     }, 100);
        // } else {
        //     $button.addClass('clicked')
        // }
    });
    $('body').on('touchstart', ".fancy-table-button-background", function ($event) {
        $('.fancy-table-button-background').click();
    });

    // Bind the expland action for FoR filters
    $('.widget-container button').click(function ($event) {
        $event.stopPropagation()
        $(this).siblings('.list').toggleClass('active');
        $(this).toggleClass('active');
    })

    // Clicking on body to close the filters
    $('body').click(function () {
        $('.widget-container .selected').removeClass('active');
        $('.widget-container .list').removeClass('active');
    })

    // Clicking on the open filer dropdown. Stop propagation
    $('.widget-container .list').click(function ($event) {
        $event.stopPropagation();
    });
};

module.exports = TableSection4;

},{}],11:[function(require,module,exports){
/* global Papa */

"use strict";

// Constructor
var Tablesection5 = function () {
    var $table_counter = 0;
    var $tables = [];
    $(".csv-table-section5").each(function () {
        var $header; // The header row
        var $footer; // The footer row
        var $container = $(this);
        var $configuration = $container.data("configuration"); // The configuration object from the data attribute
        var $table_css_class = $configuration.style ? $configuration.style : "";
        // var $decimal_places = typeof $configuration.decimal_places === "undefined" ? false : $configuration.decimal_places; //Decimal places to show
        var $decimal_places = 0; //Decimal places to show
        var $forgroup_filter = [];
        var $institutions = [];
        var $disciplines = [];
        var $column_filters = [];
        var $total_columns_index = [];

        // Pulls the CSV data in json
        Papa.parse($configuration.url, {
            download: true,
            dynamicTyping: false,
            skipEmptyLines: true,
            complete: function ($json) {

                // Increment the table counter to use for IDs etc
                $table_counter++;

                // Process the data
                $configuration.header ? ($header = $json.data.shift()) : "";
                $configuration.footer ? ($footer = $json.data.pop()) : "";

                // Output the HTML structure for the table
                var $html = "";
                var $highlight_column = [];
                var $engagement_highlight_column = [];
                var $impact_highlight_column = [];
                var $approach_highlight_column = [];
                $html += '<table class="' + $table_css_class + '">';

                // Add the header
                if ($configuration.header) {
                    // Start the header column
                    $html += "<thead><tr>";
                    // Addind the group column
                    // $html += "<th>forgroup</th>";

                    // Go through all the header cell

                    $($header).each(function ($index, $value) {
                        // console.log($value.substr(0, $value.indexOf(' ')));
                        $value.substr(0, $value.indexOf(' ')).length === 2 ? $highlight_column.push($index) : ''; // If column is 2 digit mark to highlight

                        $value.indexOf('Engagement') > -1 ? $engagement_highlight_column.push($index) : '';
                        $value.indexOf('Impact') > -1 ? $impact_highlight_column.push($index) : '';
                        $value.indexOf('Approach') > -1 ? $approach_highlight_column.push($index) : '';
                        // console.log($value.replace(/ /g,"_"));

                        // var $forcode = $value.substring(0, 2);
                        var $forcode = $value.replace(/ /g, "_");
                        var $cell_class = "";
                        // Add class to second col to align text
                        $index === 1 ? $cell_class = "left_align" : '';

                        // Format the value to show on different line
                        var $value_formatted = $value ? "<span class='discipline'>" + $value.split('-')[0] + "</span> <span class='group'>" + $value.split('-')[1] + "</span>" : '';

                        // Add the class and cell value for the header
                        $html += "<th data-index='" + $index + "' data-forcode='" + $value + "' class='" + $cell_class + " " + $value.split('-')[1] + "'>" + $value_formatted + "</th>";
                        // If this is a total cell add to array to make background darker
                        $value.toLowerCase().indexOf('total') !== -1 ? $total_columns_index.push($index) : '';

                        $column_filters.push({ index: $index + 1, label: $value });
                        // console.log($value.substr(0, $value.indexOf(' ')))

                        if ($value.substr(0, $value.indexOf(' ')).length === 2) {
                            // $disciplines.push({ code: $value.substr(0, $value.indexOf(' ')), label: $value.substr($value.indexOf(' ') + 1) })
                            $disciplines.push({ code: $value.replace(/ /g, "_"), label: $value })

                        }
                    });

                    // console.log($disciplines);

                    $html += "</tr></thead>";
                }

                // console.log($highlight_column);
                // Addthe body
                if ($json.data) {
                    $html += "<tbody>";

                    var $forgroup = "";
                    var $forgroup_label = "";
                    var $forgroup_class = "";
                    $($json.data).each(function ($index, $row) {

                        // If the FoR code is one or 3 numbers long add the Zero prefix
                        $row[0].length < 2 || $row[0].length === 3 ? $row[0] = "0" + $row[0] : '';

                        $institutions.push({ label: $row[0] });

                        // Add the group class to the row if it is the first item
                        $html += '<tr class="' + $forgroup_class + '">';

                        // Go through each cell and add
                        $($row).each(function ($index, $cell) {
                            var $cell_class = "";

                            // Make sure the value in the cell is 1 decimal place and thousand seperated
                            if ($decimal_places && $index !== 0 && $index !== 1 && $cell !== "-" && $cell !== "n/a") {
                                $cell = parseFloat(Number($cell.replace(/,\s?/g, ""))).toFixed($decimal_places).toLocaleString();
                                $cell = Number($cell).toLocaleString() // Not sure why we need this
                            }

                            // Make sure the second column containing the FoR name is left aligned
                            // $index === 1 ? $cell_class = "left_align" : '';

                            // If cell is N/A add a class to fade
                            $cell === 'n/a' ? $cell_class += "fade" : '';

                            // If cell is marked to highlight
                            $highlight_column.indexOf($index) !== -1 ? $cell_class += " highlight" : ''; // If cell marked to highlight
                            $engagement_highlight_column.indexOf($index) !== -1 ? $cell_class += " highlight_engagement" : ''; // If cell marked to highlight
                            $impact_highlight_column.indexOf($index) !== -1 ? $cell_class += " highlight_impact" : ''; // If cell marked to highlight
                            $approach_highlight_column.indexOf($index) !== -1 ? $cell_class += " highlight_approach" : ''; // If cell marked to highlight

                            // If the cell is part of the total cell array mark it to change the background color
                            $total_columns_index.indexOf($index) !== -1 ? $cell_class += "total_cell" : '';

                            // Add the cell data and class
                            $html += "<td class='" + $cell_class + "'>" + $cell + "</td>";
                        });

                        $html += "</tr>";
                    });
                    $html += "</tbody>";
                }

                // Add the footer
                if ($configuration.footer) {

                    // Start of footer
                    $html += "<tfoot><tr>";
                    // Add a blank column for the total
                    // $html += "<td></td>";

                    // Go through each footer cell
                    $($footer).each(function ($index, $value) {
                        // Make sure the value is 1 decimal place and has thousand seperator
                        if ($decimal_places && $index !== 0 && $index !== 1 && $value !== "-") {
                            $value = parseFloat(Number($value.replace(/,\s?/g, ""))).toFixed($decimal_places).toLocaleString();
                            $value = Number($value).toLocaleString() // Not sure why we need this
                        }
                        // Add the value
                        $html += "<td>" + $value + "</td>";
                    });

                    // Close the footer
                    $html += "</tr></tfoot>";
                }

                // Close the table
                $html += "</table>";

                // Add the table on the page
                $container.html($html);



                // Create the filters for FoR group
                var $filter_html = "";

                // Go through the filter array
                $($disciplines).each(function ($index, $data) {

                    // Add the filter markup
                    $filter_html +=
                        "<li class='table_group_" + $table_counter + "'>" +
                        "<input type='checkbox' id='for-" + $table_counter + "_" + $data["code"] + "' data-table-target='" + $table_counter + "'  value='" + $data["code"] + "'/>" +
                        "<label for='for-" + $table_counter + "_" + $data["code"] + "'>" + $data["label"] + "</label>" +
                        "</li>";
                });

                // Add the FoR filter
                $container.closest('.section5-tables').find(".buttons.widget-container .list").html($filter_html);


                // Create the filters for FoR group
                var $filter_html = "";

                // Go through the filter array
                $($institutions).each(function ($index, $data) {

                    // Add the filter markup
                    $filter_html +=
                        "<li class='table_group_" + $table_counter + "'>" +
                        "<input type='checkbox' id='institution_filter_" + $table_counter + "_" + $index + "' data-table-target='" + $table_counter + "'  value='" + $data["label"] + "'/>" +
                        "<label for='institution_filter_" + $table_counter + "_" + $index + "'>" + $data["label"] + "</label>" +
                        "</li>";
                });

                // Add the FoR filter
                $container.closest('.section5-tables').find(".dropdown.widget-container .list").html($filter_html);




                // Make the dataTable
                var $columnsDefs;

                // Show only 8 columns on the display
                $columnsDefs = [
                    {
                        targets: 0,
                        searchable: true,
                        visible: true
                    },
                    {
                        // targets: [0, 1, $header.length - 1, $header.length], // We can make this a configuration
                        targets: ["_all"],
                        visible: true
                    },
                    {
                        targets: ["_all"],
                        searchable: false,
                        visible: false
                    }
                ];
                $configuration["columnDefs"] = $columnsDefs;

                // Make the table a Datatable
                $tables['table_' + $table_counter] = $container.find("table").DataTable($configuration);


                var $visible = [];
                var $hidden = [];
                var $datatable = $tables['table_' + $table_counter];

                // Bind the change action to the filter checkboxes
                $(".dropdown.widget-container .list li.table_group_" + $table_counter + " input").change(function () {

                    // When a checkbox is ticked go through the list and build the search filter
                    var $value = '';
                    var $table_target = $(this).data('table-target');
                    var $counter = 0;

                    $(this).closest('.dropdown.widget-container').find("input:checked").each(function () {
                        $value += $(this).val() + "|";
                        $counter++;
                    })

                    // console.log($value);

                    // After collecting all the values check if there is anything to filter
                    if ($value) {
                        // Use a regex to filter the full value
                        // console.log($table_target);
                        // console.log($tables['table_' + $table_target]);
                        $tables['table_' + $table_target].search("^\\s*(" + $value + ")\\s*$", true, false, true).draw();
                        $(this).closest('.widget-container').find('.selected span').html($counter);

                    } else {
                        // If no checkbox is ticked then show everything
                        $tables['table_' + $table_target].search('').draw();
                        $(this).closest('.widget-container').find('.selected span').html('All');
                    }

                });


                // Bind the change action to the filter checkboxes
                $(".buttons.widget-container .list li.table_group_" + $table_counter + " input").change(function () {

                    // When a checkbox is ticked go through the list and build the search filter
                    var $value = '';
                    var $table_target = $(this).data('table-target');
                    var $counter = 0;
                    var $selected = [];
                    var $datatable = $tables['table_' + $table_target];


                    $(this).closest('.buttons.widget-container').find("input:checked").each(function () {
                        // console.log($(this).val().replace(/_/g," "));

                        // $value += $(this).val() + "|";
                        $value += $(this).val().replace(/_/g, " ") + "|";
                        $counter++;
                        $selected.push($(this).val().replace(/_/g, " "));
                    })

                    // console.log($selected);

                    // After collecting all the values check if there is anything to filter
                    if ($value) {
                        // Use a regex to filter the full value
                        $(this).closest('.widget-container').find('.selected span').html($value.slice(0, -1).replace(/\|/g, ", "));

                        // Go through the columns and check if the for is in it the selected array
                        $datatable.columns().every(function ($index) {
                            var $forcode = $(this.header()).data('forcode');

                            if ($index > 0) {
                                // console.log('For code from header',$forcode);

                                if ($selected.indexOf($forcode) > -1 || $selected.indexOf(Number($forcode)) > -1) {
                                    this.visible(true, false);
                                } else {
                                    this.visible(false, false);
                                }
                            }
                        });
                        $datatable.columns.adjust().draw(false)

                    } else {
                        $(this).closest('.widget-container').find('.selected span').html('All');
                        $datatable.columns().visible(true);
                    }

                    $datatable.columns.adjust().draw(false)
                });


                // On page load check if there is a FOR code in the url, if there is then tick the box in the 
                // filter dropdown and filter the table
                if (getForFromURL()) {
                    var $forFromURL = getForFromURL().replace(/-/g, "_");
                    // console.log($forFromURL.replace(/-/g, "_"));
                    setTimeout(function () {
                        $(".buttons.widget-container .list li.table_group_" + $table_counter + " input").each(function () {
                            // console.log('input value: ', $(this).val().toLowerCase());
                            // console.log('input value formatted: ', $(this).val().toLowerCase().replace(/,/g, "").replace(/-/g, "").replace(/__/g, "_"));
                            // console.log('forcode:', $forFromURL);
                            // console.log("----");


                            if ($(this).val().toLowerCase().replace(/,/g, "").replace(/-/g, "").replace(/__/g, "_").indexOf($forFromURL) > -1) {
                                $(this).prop('checked', true);
                                $(this).change();
                            }
                        })
                        // $(".buttons.widget-container .list li.table_group_" + $table_counter + " input[value='" + $forFromURL + "']").prop('checked', true);
                        // $(".buttons.widget-container .list li.table_group_" + $table_counter + " input[value='" + $forFromURL + "']").change();
                    }, 200);
                }

            },
            error: function ($err, $file, $inputElem, $reason) {

                $container.closest(".collapsible-box").addClass("no-data");
                if ($err["message"] === "Not Found" || $err["message"] === "") {
                    var $textfile = $configuration.url.substr(0, $configuration.url.lastIndexOf("/") + 1) + "no.table.footnote.txt"; // remove everything after the last backslash
                    var $error_message = "Data not found";
                    $.ajax({
                        url: $textfile
                    })
                        .done(function ($data) {
                            $data ? ($error_message = $data) : "";
                            $container.replaceWith("<div class='no-table not-found'>" + $error_message + "</div>");
                        })
                        .fail(function ($error) {
                            $container.replaceWith("<div class='no-table not-found'>" + $error_message + "</div>");
                        });
                }
            }
        });
    });

    function getForFromURL() {
        var $vars = {};
        var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
            $vars[key] = value;
        });
        if ($vars['for']) {
            var $forcode = $vars['for'];
            return $forcode;
        } else {
            return false;
        }
    }

};

module.exports = Tablesection5;

},{}],12:[function(require,module,exports){
'use strict';

// Constructor
var Header = function () {
    $('.slide2').waypoint(function ($direction) {
        if ($direction === 'up') {
            $('.home .header').removeClass('shrink');
        } else {
            $('.home .header').addClass('shrink');
        }
    }, {
        offset: $('.slide1').height() / window.innerHeight * 100 * 0.87 + '%'
    });

    $('.slide2').waypoint(function ($direction) {
        if ($direction === 'up') {
            $('.home .menu-trigger').removeClass('dark');
        } else {
            $('.home .menu-trigger').addClass('dark');
        }
    }, {
        offset: '10%'
    });
    $('.slide5').waypoint(function ($direction) {
        if ($direction === 'up') {
            $('.home .menu-trigger').addClass('dark');
        } else {
            $('.home .menu-trigger').removeClass('dark');
        }
    }, {
        offset: '10%'
    });
};

module.exports = Header;

},{}],13:[function(require,module,exports){
'use strict';

// Constructor
var Slide1 = function () {
    $('.slide1').waypoint(function () {
        $('.slider button').removeClass('active');
        $('.slider .button_slide1').addClass('active');
        $('.slide1 .leaf').addClass('active');
        
    }, {
        offset: '0%'
    });        
};

module.exports = Slide1;

},{}],14:[function(require,module,exports){
'use strict';

// Constructor
var Slide2 = function () {
    var $counters = {};

    // Create the counter objects
    $('.slide2 .number').each(function () {
        $counters[$(this).data('name')] = new CountUp($(this)[0], 0, $(this).data('end'), $(this).data('decimal'), 2.5, {
            useEasing: true,
            useGrouping: true,
            separator: ',',
            decimal: '.',
            prefix: $(this).data('prefix') ? $(this).data('prefix') : '',
            suffix: $(this).data('suffix') ? $(this).data('suffix') : ''
        });

//        $(this).html('0');
    });

    // When hitting the slide animate the numbers
    $('.slide2').waypoint(function () {
        $('.slide2 .number').each(function () {
            if (!$counters[$(this).data('name')].error) {
                $counters[$(this).data('name')].start();
            } else {
                console.error($counters[$(this).data('name')].error);
            }

            $('.slider button').removeClass('active');
            $('.slider .button_slide2').addClass('active');
            $('.slide2 .right').addClass('active');
        });
    }, {
        offset: '25%'
    });

    $('.slide2').waypoint(function () {
        $('.slider button').removeClass('active');
        $('.slider .button_slide1').addClass('active');
    }, {
        offset: '99%'
    });


};

module.exports = Slide2;

},{}],15:[function(require,module,exports){
'use strict';

// Constructor
var Slide3 = function () {
    $('.slide3').waypoint(function () {
        $('.slider button').removeClass('active');
        $('.slider .button_slide3').addClass('active');

        // Activate the chart
        setTimeout(function () {
            if (window.charts_collection['home-chart']) {
                window.charts_collection['home-chart'].update({
                    duration: 800,
                    lazy: false,
                    easing: 'easeOutBounce'
                });
            }
        }, 300);
    }, {
        offset: '5%'
    });

    $('.slide3').waypoint(function () {
        $('.slider button').removeClass('active');
        $('.slider .button_slide2').addClass('active');
        $('.slide3').addClass('active');
    }, {
        offset: '99%'
    });


    // If on home page then draw the chart only when canvas in focus
    if ($('main.home').length > 0) {
        setTimeout(function () {
            if (window.charts_collection['home-chart']) {
                window.charts_collection['home-chart'].reset();
            }
        }, 100);
    }
};

module.exports = Slide3;

},{}],16:[function(require,module,exports){
'use strict';

// Constructor
var Slide4 = function () {
    $('.slide4').waypoint(function () {
        $('.slide4 .canvas').addClass('active');
        $('.slider button').removeClass('active');
        $('.slider .button_slide4').addClass('active');

    }, {
        offset: '25%'
    });

    $('.slide4').waypoint(function () {
        $('.slider button').removeClass('active');
        $('.slider .button_slide3').addClass('active');
    }, {
        offset: '99%'
    });
};

module.exports = Slide4;

},{}],17:[function(require,module,exports){
'use strict';

// Constructor
var Slide5 = function () {
    $('.slide5').waypoint(function () {
        $('.slider button').removeClass('active');
        $('.slider .button_slide5').addClass('active');
        $('.slide5 .leaf').addClass('active');
    }, {
        offset: '5%'
    });

    $('.slide5').waypoint(function () {
        $('.slider button').removeClass('active');
        $('.slider .button_slide4').addClass('active');
    }, {
        offset: '99%'
    });
};

module.exports = Slide5;

},{}],18:[function(require,module,exports){
'use strict';

// Constructor
var Slider = function () {
    $('.slides .links a, .slider button').click(function ($event) {
        $event.preventDefault();
        var $top = $(".slides." + $(this).data('slide')).offset().top ? $(".slides." + $(this).data('slide')).offset().top : 0;
        $("html, body").stop().animate({scrollTop: $top}, 500, 'swing', function () {
            // Waypoint triggers the actions
        });
    });
};

module.exports = Slider;

},{}],19:[function(require,module,exports){
'use strict';

// Constructor
var Slides = function () {
//    this.name = 'slides';
//    console.log('%s module', this.name);

    if ($('main.home').length > 0) {
        window.onbeforeprint = function (event) {

            $("html, body").stop().animate({scrollTop: document.body.scrollHeight}, 10, 'swing', function () {

                $("html, body").stop().animate({scrollTop: (document.body.scrollHeight * -1)}, 10, 'swing', function () {
                    // Waypoint triggers the actions
                });
            });
        };
    }

//    var mediaQueryList = window.matchMedia('print');
//    mediaQueryList.addListener(function (mql) {
//        if (mql.matches) {
//            console.log('webkit equivalent of onbeforeprint');
////            window.scrollTo(0, document.body.scrollHeight);
//            $('.slide2 .right').addClass('active');
//
//
//        }
//    });



};

module.exports = Slides;

},{}],20:[function(require,module,exports){
// Main javascript entry point
// Should handle bootstrapping/starting application

'use strict';

var Chartblock = require('../_modules/data/chartblock/chartblock');
var Table = require('../_modules/data/table/table');
var TableSection1 = require('../_modules/data/table/table.section1');
var TableSection4 = require('../_modules/data/table/table.section4');
var Tablesection5 = require('../_modules/data/table/table.section5');

var Header = require('../_modules/home/header/header');
var Slides = require('../_modules/home/slides/slides');
var Slide1 = require('../_modules/home/slide1/slide1');
var Slide2 = require('../_modules/home/slide2/slide2');
var Slide3 = require('../_modules/home/slide3/slide3');
var Slide4 = require('../_modules/home/slide4/slide4');
var Slide5 = require('../_modules/home/slide5/slide5');
var Slider = require('../_modules/home/slider/slider');
var CommonHeader = require('../_modules/common/header/header');
var TitleBar = require('../_modules/common/title-bar/title-bar');
var CollapsibleBox = require('../_modules/common/collapsible-box/collapsible-box');
var PageScroll = require('../_modules/common/page-scroll/page-scroll');
var TabBox = require('../_modules/common/tab-box/tab-box');
var MainNavigation = require('../_modules/common/main-navigation/main-navigation');


// Reset the chart array
window.charts_collection = [];


$(function() {
  new Chartblock();
  new Table();
  new TableSection1();
  new TableSection4();
  new Tablesection5();
  
  new CommonHeader();
  new CollapsibleBox();
  new TabBox();
  new MainNavigation();
  new PageScroll();
  new TitleBar();
  
  new Header();
  new Slides();
  new Slide1();
  new Slide2();
  new Slide3();
  new Slide4();
  new Slide5();
  new Slider();
});

},{"../_modules/common/collapsible-box/collapsible-box":1,"../_modules/common/header/header":2,"../_modules/common/main-navigation/main-navigation":3,"../_modules/common/page-scroll/page-scroll":4,"../_modules/common/tab-box/tab-box":5,"../_modules/common/title-bar/title-bar":6,"../_modules/data/chartblock/chartblock":7,"../_modules/data/table/table":8,"../_modules/data/table/table.section1":9,"../_modules/data/table/table.section4":10,"../_modules/data/table/table.section5":11,"../_modules/home/header/header":12,"../_modules/home/slide1/slide1":13,"../_modules/home/slide2/slide2":14,"../_modules/home/slide3/slide3":15,"../_modules/home/slide4/slide4":16,"../_modules/home/slide5/slide5":17,"../_modules/home/slider/slider":18,"../_modules/home/slides/slides":19}]},{},[20])

